module.exports = __webpack_public_path__ + "img/carta-tinaba.a48af6fe.png";